import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface AppConfig {
  aws: {
    accessKeyId: string;
    secret: string;
    region: string;
  };
  features?: {
    enableCitasSuspendidas?: boolean;
  };
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: AppConfig;

  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
    return this.http.get<AppConfig>('/assets/config.json')
      .toPromise()
      .then(config => {
        this.config = config;
      })
      .catch(err => {
        // Error handled silently
        // Fallback to environment values if config.json not found
        this.config = null;
      });
  }

  getAwsConfig(): AppConfig['aws'] | null {
    return this.config ? this.config.aws : null;
  }

  get appConfig(): AppConfig | null {
    return this.config;
  }

  isFeatureEnabled(feature: string): boolean {
    if (!this.config || !this.config.features) {
      return true; // Por defecto habilitado si no hay config
    }
    const value = this.config.features[feature];
    return value !== false; // Solo deshabilita si explícitamente es false
  }
}
